import React from 'react'
import DataComp from '../../../components/Admin/data'
import MasterLayoutAdmin from '../../../layout/Admin/masterLayoutAdmin'

export default function AdminData() {
    return (
        <MasterLayoutAdmin>
            <DataComp />
        </MasterLayoutAdmin>
    )
}
